export default {
  config: {
    site: {
      name: 'site name',
      domainName: '域名',
      siteID: '站点ID',
      siteCatalogs: '站点目录',
      status: '状态'
    }
  }
}
